<template>
  <a-card :bordered="false" title="下架记录" :headStyle="{fontSize:'18px'}">
    <a-form>
      <search-page-view
        :col="3"
        ref="pageList"
        :itemNames="searchItemList"
        :columns="columns"
        :queryParams="queryParams"
        @reset="resetEvent"
        row-key="shelfProId"
        :leftSpace="36"
        :showResetButton="true"
        :requestPromise="loadPromise"
      >
        <a-form-item slot="search_proId" label="商品ID" v-bind="searchItemLayout">
          <a-input v-model="queryParams.shelfProId" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="search_proName" label="商品名称" v-bind="searchItemLayout">
          <a-input v-model="queryParams.shelfName" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item slot="search_proType" label="商品分类" v-bind="searchItemLayout">
          <a-select allowClear
                    style="width: 100%"
                    v-model="queryParams.shelfCatalogId"
                    placeholder="请选择"
          >
            <a-select-option v-for="item in proCategoryList" :key="item.code" :value="item.code">{{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item slot="search_reason" label="下架原因" v-bind="searchItemLayout">
          <a-select allowClear
                    style="width: 100%"
                    v-model="queryParams.shelfReason"
                    placeholder="请选择"
          >
            <a-select-option v-for="item in dropReasonList" :key="item.code" :value="item.code">{{ item.name }}
            </a-select-option>
          </a-select>

        </a-form-item>
        <a-form-item slot="search_date" label="下架日期" v-bind="searchItemLayout">
          <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
        </a-form-item>
        <span slot="shelfCatalogId" slot-scope="rowItem">{{ rowItem.text|getAllProductTypeName }}</span>
        <span slot="shelfReason" slot-scope="rowItem">{{ rowItem.text|proInfoDrop }}</span>
      </search-page-view>
    </a-form>
  </a-card>
</template>

<script>
import SkipOtherHelper from '../../utils/helper/SkipOtherHelper'
import searchForm from '../../utils/mixins/searchFormMixins'

export default {
  name: 'OfflineRecords',
  mixins: [searchForm],
  data() {
    return {
      pageType: 1,
      searchItemList: ['search_proId', 'search_proType', 'search_proName', 'search_reason', 'search_date'],
      selectedDate: undefined,
      proCategoryList: [],
      dropReasonList: [],
      queryParams: {},
      loadPromise: params => this.getOffLineProList(params),
      columns: [
        {
          title: '商品ID',
          dataIndex: 'shelfProId'
        },
        {
          title: '商品信息',
          dataIndex: 'shelfName',
          width: '45%'
        },
        {
          title: '商品类型',
          dataIndex: 'shelfCatalogId',
          scopedSlots: { customRender: 'shelfCatalogId' }
        },
        {
          title: '下架时间',
          dataIndex: 'shelfCreatedTime'
        },
        {
          title: '下架原因',
          dataIndex: 'shelfReason',
          width: '200px',
          scopedSlots: { customRender: 'shelfReason' }
        }
      ]
    }
  },
  mounted() {
    this.getProCatalogList()
    this.dropReasonList = this.getAppConstants().getProInfoDropReason()
  },
  methods: {
    getProCatalogList() {
      this.getHttpServices().getUserService().post('api/v2/merchant/product/category/list', {})
        .then(res => {
          this.proCategoryList = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getOffLineProList(params) {
      return this.getHttpServices().getProService().post('product/shelfLog/getProInfoDropList', params)
    },
    resetEvent() {
      this.selectedDate = undefined
      this.queryParams = {}
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.beginDate = dateStrArr[0]//开始日期
      this.queryParams.endDate = dateStrArr[1]//结束日期
      this.getLogUtils().logWithTag('日期', dateStrArr)
    }
  }
}
</script>
<style scoped>
</style>